<template>
  <div class="mob-text-field" :class="sizeClass">
    <label :for="inputId" v-if="label">{{ label }}</label>
    <input
      :id="inputId"
      :name="inputName"
      :type="type"
      :disabled="disabled"
      :readonly="readonly"
      :value="value"
      :placeholder="placeholder"
      @input="$emit('input', $event.target.value)"
    />
    <span
      v-if="errorText"
      class="flex items-center gap-1 text-sm text-red-700 !-mt-0"
    >
      <!-- prettier-ignore -->
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" style="fill: currentColor;transform: ;msFilter:;"><path d="M11.953 2C6.465 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.493 2 11.953 2zM12 20c-4.411 0-8-3.589-8-8s3.567-8 7.953-8C16.391 4 20 7.589 20 12s-3.589 8-8 8z"></path><path d="M11 7h2v7h-2zm0 8h2v2h-2z"></path></svg>
      {{ errorText }}
    </span>
  </div>
</template>

<script>
export default {
  name: "MobTextField",
  props: {
    label: String,
    disabled: Boolean,
    readonly: Boolean,
    inputId: {
      type: String,
      default: () => `mob-input-${Math.random().toString(36).substring(7)}`,
    },
    inputName: String,
    value: String,
    size: {
      type: String,
      default: "default",
      validator: (value) => ["small", "default", "large"].includes(value),
    },
    placeholder: String,
    type: {
      type: String,
      default: "text",
      validator: (value) =>
        ["text", "number", "email", "password"].includes(value),
    },
    errorText: String,
  },
  computed: {
    sizeClass() {
      return {
        "mob-text-field--sm": this.size === "small",
        "mob-text-field--base": this.size === "default",
        "mob-text-field--lg": this.size === "large",
      };
    },
  },
};
</script>

<style scoped>
.mob-text-field {
  @apply space-y-2;
}

.mob-text-field label {
  @apply text-neutral-700 block font-medium text-left;
}

.mob-text-field input {
  @apply rounded-md border border-neutral-300 px-3 py-2 w-full;
}

.mob-text-field input::placeholder {
  @apply text-neutral-500;
}

.mob-text-field--sm input {
  @apply text-sm py-1.5;
}

.mob-text-field--lg input {
  @apply p-4;
}

.mob-text-field {
}
</style>
